import * as React from 'react';

import { HotelViewModel } from 'models';

export interface SupportingMessagesProps {
  supportingMessages: HotelViewModel['supportingMessages'];
}

export const SupportingMessages: React.FunctionComponent<SupportingMessagesProps> = ({ supportingMessages }) => (
  <RenderBoldSupportingMessages supportingMessages={supportingMessages} />
);
const RenderBoldSupportingMessages = ({ supportingMessages }) => (
  <>
    {supportingMessages &&
      supportingMessages.length > 0 &&
      supportingMessages.map((supportingMessage, index) => (
        <div
          className={`supporting-message excluding-tax
               uitk-cell pwa-theme--grey-700 uitk-type-right uitk-type-100 ${index === 0 ? 'uitk-type-bold' : ''}`}
          key={`supportingMessage-${index}`}
        >
          {supportingMessage}
        </div>
      ))}
  </>
);
